module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "content_title"
  }, [_vm._v(_vm._s(_vm.catedetailDataArr.name))]), _vm._v(" "), _c('div', {
    staticClass: "content_date"
  }, [_vm._v("发布日期：" + _vm._s(_vm._f("timeFormat")(_vm.catedetailDataArr.update_time)))]), _vm._v(" "), _c('div', {
    staticClass: "content_container html-data",
    domProps: {
      "innerHTML": _vm._s(_vm.catedetailDataArr.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0007ef30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/CateSinglePage.vue
// module id = 1130
// module chunks = 0